import React, { Component } from "react";
import { connect } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";

import { logar } from "../../actions";

import "../login/sign.css";

class Login extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
      senha: "",
      recaptchaResponse: undefined,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.logar = this.logar.bind(this);

    this.handleCaptchaResponseChange =
      this.handleCaptchaResponseChange.bind(this);
  }

  handleInputChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  logar(event) {
    const { email, senha, recaptchaResponse } = this.state;
    event.preventDefault();
    if (email.trim() == "" || senha.trim() == "" || !recaptchaResponse) return;
    else this.props.logar({ email, senha, recaptchaResponse });
  }

  handleCaptchaResponseChange(response) {
    this.setState({
      recaptchaResponse: response,
    });
  }

  render() {
    const { loading_auth, error_auth } = this.props.auth;

    return (
      <div
        className="principal"
        style={{ width: "100%", marginTop: 0, display: "flex" }}
      >
        <form className="form-signin" onSubmit={this.logar}>
          <img
            className="mb-4"
            src="/assets/imagem/logo-finsol.png"
            alt="logo-finsol"
            width="90%"
            height="90%"
          />
          <h1 className="h3 mb-3 font-weight-normal">Seja bem vindo</h1>

          <label className="sr-only">E-mail</label>
          <input
            name="email"
            type="email"
            id="inputEmail"
            className="form-control"
            placeholder="E-mail"
            required
            onChange={this.handleInputChange}
          />

          <label className="sr-only">Senha</label>
          <input
            name="senha"
            type="password"
            id="inputPassword"
            className="form-control"
            placeholder="Senha"
            required
            onChange={this.handleInputChange}
          />

          <div className="form-group">
            <ReCAPTCHA
              ref={(el) => {
                this.recaptcha = el;
              }}
              sitekey="6LeD2t8ZAAAAAEo71n09K1ukjh-QTUUQ0SeDxMA0"
              onChange={this.handleCaptchaResponseChange}
            />
          </div>

          <div className="checkbox mb-3">
            <label>
              <input type="checkbox" value="remember-me" /> Lembrar-me
            </label>
          </div>

          {/* <div className="form-group">
                        <a href="/cadastrar" > cadastrar-se </a>
                    </div> */}

          <button
            className="btn btn-lg btn-primary btn-block"
            type="submit"
            role="button"
            disabled={loading_auth}
          >
            {loading_auth ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            ) : null}
            {loading_auth ? "   Aguarde..." : "Entrar"}
          </button>

          {error_auth != "" ? (
            <div
              className="alert alert-danger"
              role="alert"
              style={{ marginTop: "5%" }}
            >
              {error_auth}
            </div>
          ) : null}
          <p className="mt-5 mb-3 text-muted">
            &copy; RBMWEB {new Date().getFullYear()}
          </p>
        </form>
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  return {
    auth,
  };
};

export default connect(mapStateToProps, {
  logar,
})(Login);
